import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { UtilityActions } from '../types';

export default function removeOrderSummaryItem(number: string): UtilityActions {
  return standardAction(ActionTypes.REMOVE_ORDER_SUMMARY_ITEM, number);
}
